import { render, staticRenderFns } from "./Destinationlist.vue?vue&type=template&id=2ebe0812&scoped=true&"
import script from "./Destinationlist.vue?vue&type=script&lang=js&"
export * from "./Destinationlist.vue?vue&type=script&lang=js&"
import style0 from "./Destinationlist.vue?vue&type=style&index=0&id=2ebe0812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe0812",
  null
  
)

export default component.exports